import { yupResolver } from '@hookform/resolvers/yup'
import React, { useRef, useState } from 'react'
import { useForm } from 'react-hook-form'
import Button from '../../../../components/Button'
import { Container, Form } from '../../../../components/commons'
import Modal from '../../../../components/Modals/Modal'
import useToast from '../../../../hooks/useToast'
import { api } from '../../../../services/api'

import {
  DocumentTypeDataForm,
  ImportDocumentForm,
  registerDocumentTypeSchema,
  registerDocumentTypeWithDataSchema,
} from '../../../../validators/document.schemas'
import MetaDataInput from './MetaDataInput'

import { SelectDocumentType } from '../../../../components/Modals/ModalUpload'

export interface CreateProps {
  overlayRef: any
}

export interface ModalHandle {
  openFormModal: () => void
}

type ModalRef = React.ElementRef<typeof Modal>

const ImportIndexsModal: React.ForwardRefRenderFunction<ModalHandle, CreateProps> = (
  { overlayRef },
  ref,
) => {
  const [loading, setLoading] = useState(false)

  const toast = useToast()

  const [lines, setLines] = React.useState<any>([])
  const [documentTypeInfo, setDocumentTypeInfo] = React.useState<DocumentTypeDataForm>()

  const modalRef = useRef<ModalRef>(null)

  const handleOpenModalCreate = () => {
    modalRef.current?.openModal()
  }

  const {
    control,
    handleSubmit,
    reset,
    getValues,
    setError,
    watch,
    formState: { errors },
  } = useForm<ImportDocumentForm>({
    defaultValues: {},
    resolver: yupResolver(registerDocumentTypeWithDataSchema),
  })
  const documentType = watch('documentType')

  const handleSubmitLogin = async (formData: ImportDocumentForm) => {
    try {
      let error = false

      formData.metadata?.map((el, index) => {
        if (el.name === '') {
          error = true

          setError(`metadata.${index}.name`, { type: 'custom', message: 'Preencha o campo' })
        }
      })

      if (error) {
        return
      }

      overlayRef.current?.handleOpen()

      setLoading(true)

      let newMetadataLines = []
      for (const line of lines) {
        let metadata: any = documentTypeInfo?.metadata

        let newMetadata: any = []

        for (const meta of metadata) {
          let payloadMeta: any = {}
          const findIndex = formData.metadata?.findIndex((metaForm) => metaForm.name === meta.name)
          if (typeof findIndex !== 'undefined' && findIndex !== -1) {
            if (typeof line[findIndex] !== 'undefined') {
              payloadMeta.value = line[findIndex].replace(/\r/g, '')
              payloadMeta.name = meta.name
              newMetadata.push(payloadMeta)
            }
          }
        }
        newMetadataLines.push(newMetadata)
      }

      for (const metadata of newMetadataLines) {
        try {
          await api.post(`/dashboard/importIndex`, {
            documentType: formData.documentType,
            metadata: metadata,
          })
        } catch (error) {
          console.log(error)
        }
      }

      toast.successToast('Index cadastrados com sucesso !')
    } catch (error) {
      toast.errorToast('Erro ao criar Tipo de Documento !')
    } finally {
      setLoading(false)
      overlayRef.current?.handleClose()
      modalRef.current?.closeModal()
    }
  }

  React.useImperativeHandle(ref, () => ({
    openFormModal() {
      reset()
      setDocumentTypeInfo(undefined)
      setLines([])
      handleOpenModalCreate()
    },
  }))

  const onGetOptions = async () => {
    try {
      const { data: response } = await api.get(`/documentTypes/${documentType}`)

      setDocumentTypeInfo(response)
    } catch (error) {}
  }

  React.useEffect(() => {
    if (documentType) onGetOptions()
    else setDocumentTypeInfo(undefined)
  }, [documentType])

  return (
    <>
      <Modal title='Importar Index' maxWidth={800} ref={modalRef}>
        <Container>
          <Form onSubmit={handleSubmit(handleSubmitLogin)}>
            <SelectDocumentType menuPosition={'fixed'} control={control} />

            <MetaDataInput
              label='Importar documentos'
              getValues={getValues}
              setLines={setLines}
              lines={lines}
              documentTypeInfo={documentTypeInfo}
              setError={setError}
              error={errors.metadata}
              control={control}
              name='metadata'
            />

            <Button
              label={lines.length > 0 ? `Importar ${lines.length} documentos` : 'Importar'}
              loading={loading}
              disabled={!documentTypeInfo || !lines.length}
              type='submit'
              variantType='block'
              color='primary'
            />
          </Form>
        </Container>
      </Modal>
    </>
  )
}

export default React.forwardRef(ImportIndexsModal)
